﻿import { createSignal, createEffect } from 'solid-js';
import { render } from 'solid-js/web';
import { findElementById } from '../Utils';
import { createDebounce } from '../Hooks/createDebounce';
import { LocationsResults } from '../Components/Location/LocationResults';
import { getCurrentPosition, GeoPosition } from '../Utils/geoLocation';

function parsePageSize(input: string, defaultValue: number) {
    const pageSize = parseInt(input);

    if (Number.isNaN(pageSize))
        return defaultValue;

    if (pageSize <= 0)
        return defaultValue;

    return pageSize;
}

/*
 *
 */
export function registerLocationsBlock(): void {
    const $results = findElementById<HTMLFormElement>('locationsBlockResults');
    const $query = findElementById<HTMLInputElement>('locationsBlockQuery');
    const $nearMe = findElementById('locationsBlockNearMe');

    // Missing target elements -> Early exit
    if (!$results || !$query || !$nearMe) {
        return;
    }

    const [ currentPosition, setCurrentPosition ] = createSignal<GeoPosition|null>(null);
    const [ query, setQuery ] = createSignal('');
    const pageSize = parsePageSize($results.getAttribute('data-page-size') ?? '', 9);

    const debounceSetQuery = createDebounce((value) => {
        setQuery(value);
        setCurrentPosition(null);
    }, 150);

    const debounceSetCurrentPosition = createDebounce((pos: GeolocationPosition) => {
        setQuery('');
        setCurrentPosition({ lat: pos.coords.latitude, lng: pos.coords.longitude });
    }, 150);

    createEffect(() => {
        if ($query.value === query())
            return;

        $query.value = query();
    });

    $query.addEventListener('input', (e) => {
        debounceSetQuery((e.currentTarget as HTMLInputElement).value);
    }, false);

    $nearMe.addEventListener('click', () => {
        const options = {
            timeout: 30 * 1000, // 30 seconds
            maximumAge: 0, // force new reading
            enableHighAccuracy: true, // force high accuracy
        };

        // Try to get position
        getCurrentPosition(options)
            .then(debounceSetCurrentPosition)
            .catch(console.error);
    }, false);

    render(() => <LocationsResults pageSize={pageSize} query={query()} currentPosition={currentPosition()} />, $results);
}
